import React, { useState } from 'react';
import { NavLink, useNavigate, Outlet } from 'react-router-dom';
import {
  LayoutDashboard, Package, Tags, ShoppingBag,
  MessageSquare, Users, Menu, X, LogOut, ChevronRight, Image, Award, FileText
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const NAV = [
  { to: '/',              label: 'Dashboard',   icon: LayoutDashboard, end: true },
  { to: '/banners',       label: 'Banners',     icon: Image },
  { to: '/brands',        label: 'Brands',      icon: Award },
  { to: '/site-content',  label: 'Site Content',icon: FileText },
  { to: '/categories',    label: 'Categories',  icon: Tags },
  { to: '/products',      label: 'Products',    icon: Package },
  { to: '/orders',        label: 'Orders',      icon: ShoppingBag },
  { to: '/inquiries',     label: 'Inquiries',   icon: MessageSquare },
  { to: '/users',         label: 'Users',       icon: Users },
];

export default function AdminLayout() {
  const { logout } = useAuth();
  const navigate   = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    toast.success('Logged out');
    navigate('/login');
  };

  return (
    <div className="admin-shell">
      {/* Sidebar */}
      <aside className={`admin-sidebar${open ? ' open' : ''}`}>
        <div className="admin-sidebar-header">
          <span className="admin-brand">
            <img src="/logo.png" alt="Swift & Sure Exim" className="admin-logo" />
            S&amp;S Admin
          </span>
          <button className="sidebar-close mobile-only" onClick={() => setOpen(false)}>
            <X size={20} />
          </button>
        </div>

        <nav className="admin-nav">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`}
              onClick={() => setOpen(false)}
            >
              <Icon size={18} />
              <span>{label}</span>
              <ChevronRight size={14} className="nav-arrow" />
            </NavLink>
          ))}
        </nav>

        <button className="admin-logout" onClick={handleLogout}>
          <LogOut size={18} /> Logout
        </button>
      </aside>

      {/* Main */}
      <div className="admin-main">
        <header className="admin-topbar">
          <button className="hamburger mobile-only" onClick={() => setOpen(true)}>
            <Menu size={22} />
          </button>
          <span className="admin-topbar-title">Swift &amp; Sure Exim — Admin</span>
        </header>
        <div className="admin-content">
          <Outlet />
        </div>
      </div>

      {open && <div className="sidebar-overlay" onClick={() => setOpen(false)} />}
    </div>
  );
}
